/*** IMPORTS FROM imports-loader ***/
(function() {

define(['jquery',
    'pip-model',
    'digitalData',
    'pip-breadcrumbs',
    'pip-events',
    'pip-common.utils',
    'pip-analytics__feature-based-recommendations',
    'pip-analytics__frequently-bought-together',
    'pip-analytics__cookie',
    'window'
  ],
  function ($,
            pip,
            DDO,
            pipBreadcrumbs,
            pipEvents,
            pipCommonUtils,
            pipFBR,
            pipFBT,
            pipAnalyticsCookie,
            window) {

    var installationSkuProductInfo;
    var deferGlobalDDOReady = $.Deferred();
    var deferBreadcrumbsReady = $.Deferred();
    var badgingInitialized = $.Deferred();
    var attachLaborDeferred = $.Deferred();
    var isSet = false;

    function collectionReady() {
      if (!isSet) {
        window._T = window._T || {};

        if (typeof window._T.pageData === 'undefined') {
          window._T.pageData = [];
        }

        window._T.pageData.push(getPIPPageData());
        isSet = true;
      }
    }

    function collectionUpdate() {
      window._T = window._T || {};

      if (typeof window._T.pageData === 'undefined') {
        window._T.pageData = [];
      }

      window._T.pageData.push(getPIPPageData());
    }

    function determineProductAvailabilityType() {
      return (pip.products.primary.data.itemExtension.browseOnlyItem && pip.fulfillment.fulfillable)
        ? 'Store Only'
        : pip.products.primary.data.availabilityType;
    }

    function pgUnloadEvent() {
      if (window._T) {
        _T.flags = _T.flags ? _T.flags : {};
        _T.flags.pgUnloadEvent = true;
      }
    }

    function makeEverythingLowerCase(obj) {
      for (var key in obj) {
        if (obj[key] === null) {
          continue;
        }
        if (typeof obj[key] !== 'string') {
          continue;
        }
        obj[key] = obj[key].toLowerCase();
      }
      return obj;
    }

    function getHdppDisplayedPreloadEvent() {
      return {
        eventMode: 'preload',
        category: {
          primaryCategory: 'hdpp content'
        },
        eventInfo: {
          eventName: 'hdpp display'
        },
        item: [{
          productInfo: {
            displayedProtectionPlan: true
          }
        }]
      };
    }

    function getETA() {
      var eta;

      var buyOnlineShipToStore = pip.fulfillment && pip.fulfillment.store && pip.fulfillment.store.buyOnlineShipToStore;
      var shipToHome = pip.fulfillment && pip.fulfillment.shipping && pip.fulfillment.shipping.shipToHome;

      if (buyOnlineShipToStore && buyOnlineShipToStore.rawEstimatedStartDeliveryDate) {
        eta = {
          bossStartDate: buyOnlineShipToStore.rawEstimatedStartDeliveryDate,
          bossEndDate: buyOnlineShipToStore.rawEstimatedEndDeliveryDate || buyOnlineShipToStore.rawEstimatedStartDeliveryDate
        }
      }

      if (shipToHome && shipToHome.rawEstimatedShippingStartDate) {
        eta = eta || {};
        eta.sthStartDate = shipToHome.rawEstimatedShippingStartDate;
        eta.sthEndDate = shipToHome.rawEstimatedShippingEndDate || shipToHome.rawEstimatedShippingStartDate;
      }

      return eta;
    }

    function getPageTemplate() {
      var templateType = "default";
      var hasApplianceExperienceQueryString = (window.location.search.indexOf('exp=appliance') !== -1)
      if (pip.products.primary.data.itemExtension.majorAppliance) {
        templateType = "appliance|default"
      }
      if (hasApplianceExperienceQueryString) {
        templateType = "appliance|v1"
      }
      return templateType;
    }

    function getAvailabilityStatus() {
      var availabilityStatus = $.extend(
        true,
        {},
        pip.viewModel.buybelt.availabilityStatus,
        getSKUStatus(),
        {
          type: determineProductAvailabilityType(),
          subscription: !!pip.subscribeAndSaveEligible
        }
      );
      if (pip.features.pageLoadBackOrderableAnalyticsEnabled) {
        var isBackOrder = pipCommonUtils.deepGet(pip, 'inventory.online.isBackordered');
        availabilityStatus.backOrder = isBackOrder ? 'yes' : 'no';
      }
      return availabilityStatus;
    }

    function getSKUStatus() {
      var userStoreIndex = 0;
      var onlineStoreIndex = 1;

      return {
        store: {
          skuStatus: getStoreStatusType(userStoreIndex)
        },
        shipping: {
          skuStatus: getStoreStatusType(onlineStoreIndex)
        }
      }
    }

    function getStoreStatusType(storeSkusIndex) {
      return pip && pip.products && pip.products.primary && pip.products.primary.data &&
        pip.products.primary.data.storeSkus &&
        pip.products.primary.data.storeSkus[storeSkusIndex] &&
        pip.products.primary.data.storeSkus[storeSkusIndex].storeStatusType &&
        pip.products.primary.data.storeSkus[storeSkusIndex].storeStatusType.toLowerCase();
    }

    /**
     * Get store type.
     * Check if product is at anchor store or at nearby, return not localized if user doesn't select store
     * @return {string} Possible values 'not localized' 'anchor' 'nearby'
     */
    function getStoreType() {
      if (pip.customer.isLocalized) {
        return pip.isAnchorStore ? 'anchor' : 'nearby';
      }
      return 'not localized';
    }

    function getPIPPageData() {

      var product;

      var _DDO = window.digitalData || {};
      var breadcrumbData = pipBreadcrumbs.getBreadcrumbData();

      _DDO.page = {
        pageInfo: {
          pageName: 'productDetails>' + pip.products.primary.data.itemId,
          pageLoadEvent: 'product view',
          pageType: 'PIP',
          pageTemplate: getPageTemplate()
        },
        category: {
          primaryCategory: breadcrumbData.bcEnsightenData.siteSection,
          subCategory1: breadcrumbData.bcEnsightenData.contentCategory,
          subCategory2: breadcrumbData.bcEnsightenData.contentSubCategory
        },
        error: []
      };

      if (pip.errorState) {
        _DDO.page.error = [pip.errorState];
      }
      if(pip.products.primary.data.itemAvailability &&
          pip.products.primary.data.itemAvailability.discontinuedItem) {
        _DDO.page.error.push({
          message: "this item is discontinued",
          type: 'error',
          displayType: 'page',
          pageSection: 'pip'
        });
      }
      _DDO.page.pageInfo = makeEverythingLowerCase(_DDO.page.pageInfo);
      _DDO.page.category = makeEverythingLowerCase(_DDO.page.category);
      product = {
        productInfo: {
          sku: pip.products.primary.data.itemId,
          productType: pip.products.primary.data.itemType,
          productName: pip.products.primary.data.info.productLabel,
          manufacturer: pip.products.primary.data.info.brandName || 'unbranded',
          availabilityStatus: getAvailabilityStatus()
        }
      }

      _DDO.product && _DDO.product[0] && _DDO.product[0].productInfo ? $.extend(_DDO.product[0].productInfo, product.productInfo) : _DDO.product = new Array(product);

      if (pip.features.multistoreFeatureEnabled) {
        _DDO.product[0].productInfo.storeType = getStoreType();
      }

      if (pip.serviceAddOns && pip.serviceAddOns.proReferral) {
        _DDO.product[0].productInfo.proReferralDisplayed = true;
      }

      if (installationSkuProductInfo) {
        _DDO.product.push({
          productInfo: installationSkuProductInfo
        });
      }

      var eta = getETA();
      if (eta) {
        if (_DDO.product
          && _DDO.product[0]
          && _DDO.product[0].productInfo
          && !_DDO.product[0].productInfo.eta) {
          _DDO.product[0].productInfo.eta = {};
        }
        $.extend(_DDO.product[0].productInfo.eta, eta);
      }

      if (pip.protectionPlan) {
        _DDO.event.push(getHdppDisplayedPreloadEvent());
      }

      if (pip.products.primary.data.itemExtension.instantRebate) {
        _DDO.product.push({
          price: {
            priceType: 'price displayed: instant rebate strike through'
          }
        });
      }

      if (pipAnalyticsCookie.hasCookie('fbr')) {
        _DDO.product[0].recommendation = pipFBR.getPageLoadObject();
        pipAnalyticsCookie.deleteCookie('fbr');
      }

      if (pipAnalyticsCookie.hasCookie('fbt')) {
        _DDO.product[0].recommendation = pipFBT.getPageLoadObject();
        pipAnalyticsCookie.deleteCookie('fbt');
      }

      if (pip.features.customProductOfferingEnabled && pip.isB2BCustomer) {
        pipEvents.customProductOffering.cpoInfoReceived.on(
          function (event, cpoResponse) {
            var value = 'not custom catalog';
            if (!cpoResponse.isPending && cpoResponse.inCpo) {
                value = 'custom catalog';
            }
            _DDO.product[0].productInfo.customProduct = value;
          });
        }

      pipEvents.badging.badgingInitialized.off('.badgingInitialized');
      pipEvents.badging.badgingInitialized.on('.badgingInitialized', function () {
        if (pip.viewModel.badging && pip.viewModel.badging.filteredBadges) {
          _DDO.product[0].productInfo.badge = pip.viewModel.badging.filteredBadges.map(function (badge) {
            return {
              type: badge.label,
              recommendationVersion: "model1",
              recommendationStrategy: "n/a"
            }
          });
        }
      });

      if (pip.debugMode) console.log('PIP_DDO:', _DDO);

      return _DDO;
    };

    function handleAttachLaborAvailability() {
      // TODO: Checking experiences here is a horrible pattern.  It would be much better to design out how
      // to register a set of lifecycle events for a particular experience.
      if (pip.experience === "default_minimal") {
        pipEvents.pipLifecycleEvents.attachLabor.attachLaborProcessed.on(function (homeServicesAddOnAvailability) {
          if (homeServicesAddOnAvailability
            && homeServicesAddOnAvailability.isAvailable
            && pip.installationSku
            && pip.installationSku.installSku) {

            installationSkuProductInfo = {
              sku: pip.installationSku.installSku,
              installationDisplayed: true
            };
          }
          attachLaborDeferred.resolve();
        });
      } else {
        attachLaborDeferred.resolve();
      }
    }

    return {
      init: function () {
        $(window.document).on('globalDDOready', deferGlobalDDOReady.resolve);

        // TODO: Consider better approach to this edge case, instead of directly referencing experience.
        if (pip.experience !== null) {
          badgingInitialized.resolve();
        }

        pipEvents.breadcrumbs.breadcrumbsLoaded.on('.breadcrumbsLoaded', deferBreadcrumbsReady.resolve);
        pipEvents.badging.badgingInitialized.on('.badgingInitialized', badgingInitialized.resolve);
        handleAttachLaborAvailability();

        pipEvents.ssku.sskuInteraction.off('.sskuInteraction');
        pipEvents.ssku.sskuInteraction.on('.sskuInteraction', function (eventType, data) {
          if (window.digitalData && window.digitalData.product && window.digitalData.product.length > 0 && window.digitalData.product[0].productInfo && data) {
            window.digitalData.product[0].productInfo.superDuperSkuInteraction = data.originatedFromSdsku;
            window.digitalData.product[0].productInfo.sskuInteraction = !data.originatedFromSdsku;
          }
          collectionUpdate();
          DDO.init();
        })

        $(window)
          .on("unload", pgUnloadEvent)
          .on('unload', collectionReady);

        $.when(deferGlobalDDOReady,
          deferBreadcrumbsReady,
          badgingInitialized,
          attachLaborDeferred).done(collectionReady);

        DDO.init();
      }
    };
  });

}.call(window));